"use strict";
var _a;
exports.__esModule = true;
exports.AircraftTypeStringMap = exports.AircraftType = void 0;
/**
 0 = (reserved)
 1 = glider/motor glider (turbo, self-launch, jet) / TMG
 2 = tow plane/tug plane
 3 = helicopter/gyrocopter/rotorcraft
 4 = skydiver, parachute (Do not use for drop plane!)
 5 = drop plane for skydivers
 6 = hang glider (hard)
 7 = paraglider (soft)
 8 = aircraft with reciprocating engine(s)
 9 = aircraft with jet/turboprop engine(s)
 A = unknown
 B = balloon (hot, gas, weather, static)
 C = airship, blimp, zeppelin
 D = unmanned aerial vehicle (UAV, RPAS, drone)
 E = (reserved)
 F = static obstacle
 */
var AircraftType;
(function (AircraftType) {
    AircraftType[AircraftType["_RESERVED_"] = 0] = "_RESERVED_";
    AircraftType[AircraftType["GLIDER"] = 1] = "GLIDER";
    AircraftType[AircraftType["TOW_PLANE"] = 2] = "TOW_PLANE";
    AircraftType[AircraftType["HELICOPTER"] = 3] = "HELICOPTER";
    AircraftType[AircraftType["PARACHUTE"] = 4] = "PARACHUTE";
    AircraftType[AircraftType["DROP_PLANE"] = 5] = "DROP_PLANE";
    AircraftType[AircraftType["HANG_GLIDER"] = 6] = "HANG_GLIDER";
    AircraftType[AircraftType["PARAGLIDER"] = 7] = "PARAGLIDER";
    AircraftType[AircraftType["AIRCRAFT_REC"] = 8] = "AIRCRAFT_REC";
    AircraftType[AircraftType["AIRCRAFT_JET"] = 9] = "AIRCRAFT_JET";
    AircraftType[AircraftType["UNKNOWN"] = 10] = "UNKNOWN";
    AircraftType[AircraftType["BALLON"] = 11] = "BALLON";
    AircraftType[AircraftType["AIRSHIP"] = 12] = "AIRSHIP";
    AircraftType[AircraftType["UAV"] = 13] = "UAV";
    AircraftType[AircraftType["_RESERVED2_"] = 14] = "_RESERVED2_";
    AircraftType[AircraftType["STATIC_OBSTACLE"] = 15] = "STATIC_OBSTACLE";
})(AircraftType = exports.AircraftType || (exports.AircraftType = {}));
exports.AircraftTypeStringMap = (_a = {},
    _a[AircraftType._RESERVED_] = '(reserved)',
    _a[AircraftType.GLIDER] = 'Glider/MotorGlider',
    _a[AircraftType.TOW_PLANE] = 'Tow/Tug Plane',
    _a[AircraftType.HELICOPTER] = 'Helikopter/Rotorcraft',
    _a[AircraftType.PARACHUTE] = 'Parachute/Skydiver',
    _a[AircraftType.DROP_PLANE] = 'Drop Plane',
    _a[AircraftType.HANG_GLIDER] = 'Hang Glider',
    _a[AircraftType.PARAGLIDER] = 'Para Glider',
    _a[AircraftType.AIRCRAFT_REC] = 'Powered Aircraft',
    _a[AircraftType.AIRCRAFT_JET] = 'Jet Aircraft',
    _a[AircraftType.UNKNOWN] = 'Unknown',
    _a[AircraftType.BALLON] = 'Balloon',
    _a[AircraftType.AIRSHIP] = 'Airship',
    _a[AircraftType.UAV] = 'UAV',
    _a[AircraftType._RESERVED2_] = '(reserved)',
    _a[AircraftType.STATIC_OBSTACLE] = 'static obstacle',
    _a);
